import { useNavigation } from '@react-navigation/core';
import { useParkingStore } from 'stores/parkingStore';
import { LatLng } from 'types/MapTypes';
import { LongTermNavProps, ParkNavProps } from 'types/navigation';
import { handleParkZoneSelected as setParkingZoneReactiveVars } from 'utils/mapUtils';

const useSelectParkingZone = () => {
  const { navigate: navigatePark } = useNavigation<ParkNavProps>();
  const { navigate: navigateLTP } = useNavigation<LongTermNavProps>();
  const { setParkingConditions } = useParkingStore((state) => state);
  const handleParkZoneSelected = (
    parkingZoneUid: string,
    coordinates: LatLng[] | LatLng | undefined,
    withLTP: boolean = false,
    permitForParkZone?: string,
    isStreet: boolean = false,
    directToChargeSelect: boolean = false
  ) => {
    setParkingZoneReactiveVars(
      parkingZoneUid,
      coordinates,
      withLTP,
      permitForParkZone,
      isStreet
    );
    // We have now only refactored part of the parking flow to use actual state and not reactive vars.
    // For now we keep the reactive vars that are set in above function, but parking flow is working with store now
    setParkingConditions({ selectedParkingZoneId: parkingZoneUid });
    if (withLTP) {
      navigateLTP('permitZone', { parkingZoneUid });
    } else if (directToChargeSelect) {
      navigatePark('chargeSelect', { parkingZoneUid });
    } else {
      navigatePark('parkDetail', { parkingZoneUid });
    }
  };

  return { handleParkZoneSelected };
};

export default useSelectParkingZone;
